export type TimeUnits = "milliseconds" | "seconds" | "minutes" | "hours" | "days" | "months" | "years";
export const months = ['Jan' , 'Feb' , 'Mar' , 'Apr' , 'May' , 'June' ,
    'July' , 'Aug' , 'Sep' , 'Oct' , 'Nov' , 'Dec'];
type Units = TimeUnits | "bytes" | "terabytes" | "gigabytes";

const conversionTable = [
    { from: 'seconds', to: 'minutes', conversionFactor: 60 },
    { from: 'bytes', to: 'terabytes', conversionFactor: 1024 * 1024 * 1024 * 1024 },
    { from: 'bytes', to: 'gigabytes', conversionFactor: 1024 * 1024 * 1024 },
    { from: 'months', to: 'years', conversionFactor: 12 }
];

export const convert = (from: Units, to: Units, amount: number, precision: number = 0) => {
    const conversionUp = conversionTable.find(x => x.from === from && x.to === to);
    const conversionDown = conversionTable.find(x => x.to === from && x.from === to);

    if(conversionUp) {
        const res = round(amount/conversionUp.conversionFactor, precision);
        return Number.isNaN(res) ? null : res; 
    }

    if(conversionDown){
        const res = round(amount*conversionDown.conversionFactor, precision);
        return Number.isNaN(res) ? null : res; 
    }
    
    console.log(`conversion not found from ${from} to ${to}. Returning input value`);
    return amount;
}

export const round = (value, precision) => {
    const multiplier = Math.pow(10, precision || 0);
    return Math.floor(value * multiplier) / multiplier;
}

export const formatDuration = (value: number, units:  'minutes' | 'seconds') => {
    if(value === null || value === undefined){
        return null;
    }

    let minPartRaw: number = null;
    let minPart: number = null;

    if(units === 'minutes'){
        minPartRaw = value;
        minPart = Math.floor(value);
    } else {
        minPartRaw = convert('seconds', 'minutes', value, 2);
        minPart = Math.floor(minPartRaw);
    }

    return `${minPart} mins`;
}

export const convertToPercent = (part: number, total: number, precision: number = 0): number => {
    if(total === 0){
        return 0;
    }
    return round((part / total) * 100, precision);
}

export const convertDateToMonth = (date: Date, includeYearAtBoundary: boolean = true): string => {
    if(includeYearAtBoundary && (date.getMonth() === 0 || date.getMonth() === 11)) {
        return `${months[date.getMonth()]} ${date.getFullYear()}`;
    }
    return months[date.getMonth()];
}

export const convertMonthKeyToDate = (monthKey: string): Date => {
    const [year, month] = monthKey.split('/').map(x => parseInt(x));
    return new Date(year, month - 1);
}